define([
	'internal_util/Util',
	'internal_util/LocalizationUtil',
	'internal_util/Logger',
	'internal_util/Configuration',
	'model/Image',
	'model/Error',
	'model/ErrorType',
	'service/EventListenerRegistry',
	'amdi18n-loader?!internal_util/nls/UiUtil_strings',
	'lib/jquery',
//	'lib/fontfaceonload',
	'lib/scrollto' // export not needed
], function (
	Util,
	LocalizationUtil,
	Logger,
	Configuration,
	Image,
	Error,
	ErrorType,
	EventListenerRegistry,
	Strings,
	jQuery//,
//	FontLoader
) {
	'use strict';

	var _loadedImages = {},
		_scrollContainer = null;


	// private methods

	function log(method, message, data) {
		Logger.log('UiUtil', method, message, data);
	}

	function callLog(method, message, data, event, callbacks) {
		log(method, message, data);
		EventListenerRegistry.callListeners(event, data, function () {
			Util.callCallbacks(callbacks, data);
		});
	}


	// public methods

	function setScrollContainer(container) {
		_scrollContainer = jQuery(container);
	}

	function scrollTo(element) {
		if (jQuery('body').find(element).length === 0) {
			return;
		}

		try {
			_scrollContainer.scrollTo(element, {
				duration : 250,
				offset : -5,
				axis : 'y',
				interrupt : true
			});
		} catch (e) {
			// ignore
		}
	}

	function getImage(identifier, doNotLoad) {
		var locale = LocalizationUtil.getShortLocale(),
			image,
			imageUrl;

		if (Configuration.get('IMAGES').hasOwnProperty(identifier)) {
			image = Configuration.get('IMAGES')[identifier];

			if (!image.hasOwnProperty('image')) {
				if (image.hasOwnProperty(locale)) {
					image = image[locale];
				} else if (image.hasOwnProperty(LocalizationUtil.getDefaultLocale())) {
					image = image[LocalizationUtil.getDefaultLocale()];
				} else {
					throw new Error('localized image ' + identifier + ' has no entry for default locale \'' +
							LocalizationUtil.getDefaultLocale() + '\'');
				}
			}

			imageUrl = Configuration.get('IMAGES_URL') + image['image'];

			if (!doNotLoad && !_loadedImages.hasOwnProperty(identifier)) {
				_loadedImages[identifier] = new window.Image();
				_loadedImages[identifier].src = imageUrl;
			}

			return new Image(imageUrl, image['width'], image['height']);
		} else {
			throw new Error('image ' + identifier + ' not found');
		}
	}

	function preloadImages(images, callbacks, errorCallbacks) {
		var _name = 'preloadImages',
			imageCount,
			i;

		callLog(_name, Strings.preload_images_started, null, 'IMAGES_LOADING_STARTED');

		if (typeof images === 'undefined' || images === null) {
			images = new Array();

			for (i = 0; i < Configuration.get('IMAGES_TO_PRELOAD').length; i++) {
				images.push(getImage(Configuration.get('IMAGES_TO_PRELOAD')[i], true));
			}
		}

		if (Util.isArray(images)) {
			imageCount = images.length;

			for (i = 0; i < images.length; i++) {
				if (images[i] instanceof Image) {
					_loadedImages[images[i].url()] = new window.Image();

					_loadedImages[images[i].url()].onload = function () {
						if (--imageCount === 0) {
							callLog(_name, Strings.preload_images_succeeded, null, 'IMAGES_LOADING_SUCCEEDED', callbacks);
						}
					};

					_loadedImages[images[i].url()].onerror = (function (url) {
						return function () {
							var error = new Error(ErrorType.NON_RECOVERABLE, Strings.preload_images_failed,
									Strings.cant_load_image + url);

							callLog(_name, Strings.preload_images_failed, error, 'IMAGES_LOADING_FAILED', errorCallbacks);
						}
					})(images[i].url());

					_loadedImages[images[i].url()].src = images[i].url();
				}
			}
		} else if (images instanceof Image) {
			_loadedImages[images.url()] = new window.Image();

			_loadedImages[images.url()].onload = function () {
				callLog(_name, Strings.preload_images_succeeded, null, 'IMAGES_LOADING_SUCCEEDED', callbacks);
			};

			_loadedImages[images.url()].onerror = function () {
				var error = new Error(ErrorType.NON_RECOVERABLE, Strings.preload_images_failed,
						Strings.cant_load_image + url);

				callLog(_name, Strings.preload_images_failed, error, 'IMAGES_LOADING_FAILED', errorCallbacks);
			};

			_loadedImages[images.url()].src = images.url();
		} else {
			throw new Error('invalid images: ' + images)
		}
	}

	function preloadWebfonts(callbacks, errorCallbacks) {
		var _name = 'preloadWebfonts';

		callLog(_name, Strings.preload_webfonts_started, null, 'WEBFONTS_LOADING_STARTED');

//		FontLoader({
//			success: function () {
				callLog(_name, Strings.preload_webfonts_succeeded, null, 'WEBFONTS_LOADING_SUCCEEDED', callbacks);
//			},
//			error: function () {
//				var error = new Error(ErrorType.NON_RECOVERABLE, Strings.preload_webfonts_failed,
//						Strings.timeout_occurred);
//
//				callLog(_name, Strings.preload_webfonts_failed, error, 'WEBFONTS_LOADING_FAILED', errorCallbacks);
//			},
//			timeout: 50000
//		}).load();
	}

	return {
		setScrollContainer : setScrollContainer,
		scrollTo : scrollTo,
		getImage : getImage,
		preloadImages : preloadImages,
		preloadWebfonts : preloadWebfonts
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/util/UiUtil.js
// module id = 4
// module chunks = 6